import { jsx } from 'react/jsx-runtime';

/**
 * Titolo da utilizzare in un Application.Header
 */
function Title({ children }) {
    return jsx("h1", { className: "application__header-title", children: children });
}
Title.displayName = 'Application.Title';

export { Title as default };
